/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F3_QInputs */

const en_mk_sec_pg_f3_q = /** @type {(inputs: Mk_Sec_Pg_F3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can an agent read my private channels or direct messages?`)
};

const id_mk_sec_pg_f3_q = /** @type {(inputs: Mk_Sec_Pg_F3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisakah agen membaca channel privat atau pesan langsung saya?`)
};

/**
* | output |
* | --- |
* | "Can an agent read my private channels or direct messages?" |
*
* @param {Mk_Sec_Pg_F3_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f3_q = /** @type {((inputs?: Mk_Sec_Pg_F3_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F3_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f3_q(inputs)
	return en_mk_sec_pg_f3_q(inputs)
});